import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ['출입제한 기한'] },
      },
    ];
  },
  getConditions: (nav) => {
    const tabIndex = nav.tab
    const conditions = [];
    const search = nav.value;

    if (tabIndex === 0) {
      conditions.push({ key: "body.출입제한기간.eDate", operator: ">=n", value: `${new Date().format('yyyy-MM-dd')}` });
    } else {
      conditions.push({ key: "body.출입제한기간.eDate", operator: "<", value: `${new Date().format('yyyy-MM-dd')}` });
      conditions.push({ key: "body.출입제한기간.eDate", operator: "!=", value: "" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "작업자 사업장명",
        key: "body.작업자정보.작업자.field.field_name",
      },
      {
        name: "업체명",
        key: "body.company.com_name",
      },
      {
        name: "담당부서",
        key: "body.작업자정보.작업자.담당부서",
      },
      {
        name: "아이디",
        key: "body.작업자정보.작업자.username",
      },
      {
        name: "내국인/외국인",
        key: "body.작업자정보.작업자.isForeigner",
      },
      {
        name: "직책",
        key: "body.작업자정보.작업자.rank",
      },
      {
        name: "이름",
        key: "body.작업자정보.작업자.name",
      },
      {
        name: "직종",
        key: "body.작업자정보.작업자.department",
      },
      {
        name: "휴대폰번호",
        key: "body.작업자정보.작업자.phone",
      },
      {
        name: "출입제한 기한",
        key: "",
      },
      {
        name: "제한 사업장",
        key: "body.제한사업장",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).작업자정보.작업자.field.field_name; // 사업장명
        case 1: return func.getContent(value).작업자정보.작업자.company.com_name; // 업체명
        case 2: return func.getContent(value).작업자정보.작업자.담당부서; // 담당부서
        case 3: return func.getContent(value).작업자정보.작업자.username; // 아이디
        case 4: return func.getContent(value).작업자정보.작업자.isForeigner ? '외국인' : '내국인'; // 내국인/외국인
        case 5: return func.getContent(value).작업자정보.작업자.rank; // 직책
        case 6: return func.getContent(value).작업자정보.작업자.name; // 이름
        case 7: return func.getContent(value).작업자정보.작업자.department; // 직종
        case 8: return func.getContent(value).작업자정보.작업자.phone; // 휴대폰번호
        case 9: {
          const 출입제한기간 = func.getContent(value).출입제한기간
          if (출입제한기간) {
            return `${출입제한기간.sDate} ~ ${출입제한기간.eDate}`; // 출입제한 기한
          }
          return '~'
        }
        case 10: return (func.getContent(value).제한사업장 || []).join(", "); // 제한 사업장
        case 11: return func.getContent(value).stdInfo.field_name; // 사업장명
        case 12: return func.getContent(value).stdInfo.writer_name // 작성자
        case 13: return func.getCreatedDate(value.created_at); // 작성일
      }
      return '';
    } catch (e) {
      console.error(e);
    }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
